<template>
  <div>
    <embeder
      v-if="fileReady"
      :fileId="file.id"
      :minusHeight="minusHeight"
    ></embeder>
  </div>
</template>
<script>
import { fileInheritedDetail } from "@/api/media";
import { mapMutations } from "vuex";
import embeder from "@/components/modules/media/components/embed";
export default {
  name: "detail",
  props: {
    propFileId: {
      type: Number,
      default: () => null
    },
    minusHeight: {
      type: Number,
      default: () => 115
    }
  },
  components: { embeder },
  data() {
    return {
      fileReady: false,
      file: {},
      deletingFileId: 0
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    ...mapMutations(["closeTagDirect"]),
    init() {
      let _id = this.propFileId;
      if (_id == undefined) {
        _id = this.$route.params.id;
      }

      fileInheritedDetail({ params: { id: _id }, store: this.$store }).then(
        res => {
          if (res != false) {
            this.file = res.data.file;
            this.fileReady = true;
          }
        }
      );
    },
    onFileDeleted({ id }) {
      this.deletingFileId = 0;
      if (id != 0) {
        this.closeTagDirect(this.$route);
      }
    },

    editDoc() {
      let _h = screen.availHeight - 60;
      let _w = screen.availWidth - 20;
      window.open(
        "#/Media/EditorBlank/" + this.propFileId,
        "_blank",
        "toolbar=no,scrollbars=yes,resizable=yes,top=0,left=0,width=" +
          _w +
          ",height=" +
          _h
      );
    }
  }
};
</script>
